import type { AccountTag } from '@vision/ui/interfaces/account-tag';

export function filterTagIdsByGroups(tags: AccountTag[], groupIds: string[], tagIds: string[]): string[] {
  return tagIds.filter((id) => {
    const tag = tags.find((item) => item.id === id);
    return !!tag?.tagGroupId && groupIds.includes(tag.tagGroupId);
  });
}

export function getTagGroupIds(tags: AccountTag[]): string[] {
  return [...new Set(tags.map((tag) => tag.tagGroupId).filter((id): id is string => !!id))];
}
